import './App.css';
import Header from './Header';
import Home from './Home';
import About from './About';
import Work from './Work';

import { Routes, Route } from 'react-router-dom';

function App() {
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
<Route path="/work" element={<Work />} />
      </Routes>
    </div>
  );
}

export default App;
